export const getTextWidth = (text: string) => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  if (context) {
    context.font = '12px "Wix Madefor Display", sans-serif'
    return context.measureText(text).width + 16 // For padding on tag (8px left + 8px right)
  }
  return 0
}
